import { useEffect, useState } from 'react'

function getIsStandalone(): boolean {
  if (typeof window === 'undefined') return false
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    ('standalone' in navigator && (navigator as never)['standalone'] === true)
  )
}

export const useIsStandalone = (): boolean => {
  const [isStandalone, setIsStandalone] = useState(false)

  useEffect(() => {
    setIsStandalone(getIsStandalone())
  }, [])

  return isStandalone
}
